import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3.5, 3.5, 5.875, 3.5),
  },
  tileContainer: {
    marginTop: theme.spacing(2),
  },
  sendIcon: {
    width: theme.spacing(6.065),
    height: theme.spacing(5.675),
  },
  rotateIcon: {
    transform: 'rotate(180deg)',
  },
  iconTileTitle: {
    ...theme.typography.h4,
    textAlign: 'center',
  },
}));
